<template>
  <section class="content">
    <!-- <keep-alive> -->
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br />
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <!-- <Toast style="margin-top: 35px" /> -->
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled" />
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate" />
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled" />
              <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate" />
            </div>

            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button @click.prevent="searchInvoice" class="p-button-raised" label="Search" icon="pi pi-search" />
            </div>
            <!--            <div class="p-field p-col-12 p-md-1 p-mt-5">-->
            <!--              <Button v-if="this.salesInvoiceLists.length > 0" @click.prevent="reset"-->
            <!--                      class="p-button-raised p-button-warning" icon="pi pi-refresh" label="Reset"/>-->
            <!--            </div>-->
          </div>
        </form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <a href="#" class="p-field p-col-12 p-md-12" @click.prevent="exportCSV()"
              v-if="this.salesInvoiceLists.length > 0 && this.$store.getters.modules.includes('5.38')" >
              <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;" />
            </a>
            <label style="color:red" for="name">Note: Please click search after update!<span
                style="color:red"></span></label>
            <DataTable :value="salesInvoiceLists" :paginator="true" ref="po" :rows="100" :filters="filters"
              :rowsPerPageOptions="[100, 500, 1000]" class="p-datatable-responsive p-datatable-gridlines" data-key="id" :selection.sync="selectedProduct1" selectionMode="single">
              <Column header="S.N">
                <template #body="sl">
                  {{ sl.index + 1 }}
                </template>
              </Column>
              <Column header="Miti" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDateNepali"
                filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDateNepali']" />
                </template>
              </Column>
              <Column header="Date" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDate"
                filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDate']" />
                </template>
              </Column>
              <Column header="Bill No" :sortable="true" field="billNo" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['billNo']" />
                </template>
              </Column>
              <Column header="Customer" :sortable="true" field="accountName" filterMatchMode="contains">
                <template #body="slotProps">
                  {{ slotProps.data.accountMaster.name }}
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['accountName']" />
                </template>
                <template #footer>
                  Total:
                </template>
              </Column>
              <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['address']" />
                </template>
              </Column>
              <Column header="Vat/Pan No" :sortable="true" field="vatPanNo" filterMatchMode="contains">
                <template #body="slotProps">
                  {{ slotProps.data.accountMaster.panNo }}
                </template>
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['vatPanNo']" />
                </template>
              </Column>
              <Column header="Store" :sortable="true" field="warehouse.name" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['warehouse.name']" />
                </template>
              </Column>
              <Column header="Sub Total" bodyStyle="text-align: right" :sortable="true" field="subTotalAmount"
                filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['subTotalAmount']" />
                </template>
                <template #footer>
                  {{ totalSubAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Non-taxable" bodyStyle="text-align: right" :sortable="true" field="nonTaxableAmount"
                filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['nonTaxableAmount']" />
                </template>
                <template #footer>
                  {{ totalNonTaxableAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Taxable" bodyStyle="text-align: right" :sortable="true" field="taxableAmount"
                filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['taxableAmount']" />
                </template>
                <template #footer>
                  {{ totalTaxableAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Discount" bodyStyle="text-align: right" :sortable="true" field="discount"
                filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['discount']" />
                </template>
                <template #footer>
                  {{ totalDiscountAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Vat" bodyStyle="text-align: right" field="vatAmount" :sortable="true"
                filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['vatAmount']" />
                </template>
                <template #footer>
                  {{ totalVatAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Total" bodyStyle="text-align: right" field="totalBillAmount" :sortable="true"
                filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['totalBillAmount']" />
                </template>
                <template #footer>
                  {{ totalSumBillAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Enter By" :sortable="true" field="enterBy" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['enterBy']"/>
                </template>
              </Column>
              <Column header="Update By" :sortable="true" field="updatedBy" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['updatedBy']"/>
                </template>
              </Column>
              <Column header="Sold By" :sortable="true" field="soldBy" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['soldBy']"/>
                </template>
              </Column>
              <Column header="Org Name" :sortable="true" field="organisationName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['organisationName']"/>
                </template>
              </Column>
      <Column header="Action" headerStyle="width:12em">
                <template #body="slotProps">
                  <Button 
      v-if="enableEdit && !irdActive" 
      class="p-button-raised p-button-success" 
      v-tooltip.top="'Edit'" 
      @click="editSalesInvoice(slotProps.data)" 
      icon="pi pi-pencil"
    />
    <!-- <Button 
      v-else 
      disabled 
      class="p-button-raised p-button-success" 
      v-tooltip.top="'Edit'" 
      icon="pi pi-pencil"
    /> -->
    
    <Button 
      v-if="enableDelete" 
      class="p-button-raised p-button-danger" 
      v-tooltip.top="irdActive ? 'Cancel' : 'Delete'"
      @click="openDeleteDialog(slotProps.data.id)" 
      :icon="irdActive ? 'pi pi-times-circle' : 'pi pi-trash'"
    />
    <!-- <Button 
      v-else 
      disabled 
      class="p-button-raised p-button-danger" 
      v-tooltip.top="isIRDActive ? 'Cancel' : 'Delete'"
      :icon="isIRDActive ? 'pi pi-times-circle' : 'pi pi-trash'"
    /> -->
                  <Button icon="pi pi-eye" class="p-button-raised p-button-warning" v-tooltip.top="'View Details'"
                    @click="viewPIVDetail(slotProps.data)" />
                  <Button icon="pi pi-print" class="p-button-raised" v-tooltip.top="'Print'"
                    @click="exportToPdf(slotProps.data.id)" />
                  <Button icon="pi pi-envelope" class="p-button-raised p-button-warning" v-tooltip.top="'Send Email'"
                    @click="exportMailSalesPdf(slotProps.data.id)" />
                </template>
              </Column>
              <template #empty>No record found</template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
   <Dialog
 :visible.sync="showDeleteDialog"
  header="Are you sure you want to cancel?"
  :style="{width: '40vw'}"
  :modal="true"
  :closable="false"
>
  <div class="p-fluid">
    <div class="p-field p-grid">
      <label for="deleteReason" style="font-size:12px">Cancel Reason:</label>
      <div class="p-col-12 p-md-10">
        <Textarea id="deleteReason" rows="5" v-model="deleteReason"/>
      </div>
    </div>
  </div>
  <template #footer>
    <Button class="p-button-raised p-button-danger" @click.prevent="confirmDelete" :label="irdActive ? 'Cancel' : 'Delete'"/>
    <Button class="p-button-raised p-button-success" @click.prevent="cancelDelete" label="Back"/>
  </template>
</Dialog>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import InputMask from 'primevue/inputmask'
import Textarea from 'primevue/textarea'
export default {
  name: 'salesInvoiceReport',
  props: ['status'],
  data() {
    return {
      showDeleteDialog: false,
      deleteId: null,
      deleteReason: '',
      fromDate: null,
      selectedProduct1: null,
      toDate: null,
      loading: false,
      dialogShow: false,
      irdActive: false,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      enableEdit: false,
      enableDelete: false,
      totalSubAmount: 0,
      totalNonTaxableAmount: 0,
      totalTaxableAmount: 0,
      totalVatAmount: 0,
      totalSumBillAmount: 0,
      totalDiscountAmount: 0
    }
  },
  computed: {
    salesInvoiceLists() {
      return this.$store.state.sales.salesInvoiceLists
    }
  },
  mounted() {
    if (this.status !== undefined) {
      this.$toast.add({ severity: 'success', summary: '', detail: this.status.message, life: 3000 })
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.checkEnableEdit()
    this.checkEnableDelete()
    this.loadOrganisationData()
  },
  methods: {
    async searchInvoice() {
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadSalesInvoiceLists', dat)
      console.log(resp)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({ severity: 'error', summary: '', detail: resp.data.message, life: 3000 })
      } else {
        this.$toast.add({ severity: 'success', summary: '', detail: resp.data.message, life: 3000 })
        this.totalBalance()
      }
    },
    async viewPIVDetail(data) {
      let PIHdata = {
        id: data.id,
        warehouse: data.warehouse,
        account: data.accountMaster,
        salesDate: data.purchaseSalesDateNepali,
        billNo: data.billNo,
        reportType: data.reportType,
        referenceNumber: data.referenceNumber,
        subTotalAmount: data.subTotalAmount,
        nonTaxableAmount: data.nonTaxableAmount,
        taxableAmount: data.taxableAmount,
        vatAmount: data.vatAmount,
        totalBillAmount: data.totalBillAmount,
        vatTypeEnum: data.vatTypeEnum,
        exciseChargeAmount: data.exciseChargeAmount,
        discountAmt: data.discount,
        remarks: data.remarks,
        address: data.address,
        soldBy: data.soldBy,
        amountInWords: data.amountInWords
      }
      if (data.purchaseType !== 'dairy') {
        this.$router.push({ name: 'sales Detail Report', params: { salesHeaderObj: PIHdata } })
      } else {
        this.$router.push({ name: 'sales Detail Dairy Report', params: { purchaseHeaderObj: PIHdata } })
      }
    },
    exportMailSalesPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/sendMailSalesBill/' + SOHeaderId + '/salesInvoice' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        if (response.status === 200) {
          this.$toast.add({ severity: 'success', summary: '', detail: 'Email sent successfully!', life: 3000 })
        }
      })
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/salesInvoice' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), { type: response.data.type })
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'salesInvoice.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/salesInvoice' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: { 'Accept': 'application/pdf', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), { type: response.data.type })
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'salesInvoice.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    checkEnableEdit() {
      if (this.$store.getters.modules.includes(',5.08')) {
        this.enableEdit = true
      }
    },
    openDeleteDialog(id) {
      this.deleteId = id
      this.deleteReason = ''
      this.showDeleteDialog = true
    },
    confirmDelete() {
      if (!this.deleteReason) {
        this.$toast.add({severity: 'warn', summary: 'Warning', detail: 'Please provide a reason', life: 3000})
        return
      }
      this.deleteReport(this.deleteId, this.deleteReason)
      this.showDeleteDialog = false
      this.deleteId = null
      this.deleteReason = ''
    },
    cancelDelete() {
      this.showDeleteDialog = false
      this.deleteId = null
      this.deleteReason = ''
    },
    async loadOrganisationData() {
      try {
        const response = await this.$store.dispatch('loadOrganisation')
        this.irdActive = response.data.data.irdActive || false
      } catch (err) {
        console.error('Failed to load organisation:', err)
        this.irdActive = false
      }
    },
    async isIRDActive() {
      try {
        const response = await this.$store.dispatch('loadOrganisation')
        const org = response.data.data
        this.irdActive = org.irdActive || false
        return this.irdActive
      } catch (err) {
        console.error('Failed to load organisation:', err)
        return false
      }
    },
    shouldShowEditButton() {
      return this.enableEdit && !this.isIRDActive()
    },
    checkEnableDelete() {
      if (this.$store.getters.modules.includes(',5.13')) {
        this.enableDelete = true
      }
    },
    totalBalance() {
      this.totalSubAmount = 0.0
      this.totalNonTaxableAmount = 0.0
      this.totalTaxableAmount = 0.0
      this.totalVatAmount = 0.0
      this.totalSumBillAmount = 0.0
      this.totalDiscountAmount = 0.0
      for (let sale of this.salesInvoiceLists) {
        this.totalSubAmount += sale.subTotalAmount
        this.totalNonTaxableAmount += sale.nonTaxableAmount
        this.totalTaxableAmount += sale.taxableAmount
        this.totalVatAmount += sale.vatAmount
        this.totalSumBillAmount += sale.totalBillAmount
        this.totalDiscountAmount += sale.discount
      }
    },
    async editSalesInvoice(data) {
      this.$router.push({ name: 'Sales Invoice', params: { salesInvoice: data } })
    },
    async deleteReport(id, reason) {
      if (!reason || reason.trim() === '') {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Cancel reason cannot be empty!',
          life: 3000
        })
        return
      }
      let deleteRe = {
        inventoryOutHeaderId: id,
        deleteReason: reason
      }
      let resp = await this.$store.dispatch('deleteSalesInvoice', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({ severity: 'success', summary: 'successfully canceled sales', detail: resp.message, life: 10000 })
      } else {
        this.$toast.add({ severity: 'error', summary: 'error while canceling sales', detail: resp.message, life: 10000 })
      }
      this.dialogShow = false
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    reset() {
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.setEnglishDate()
      }
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    Button,
    InputMask,
    Textarea
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css"></style>



// WEBPACK FOOTER //
// salesInvoiceReport.vue?678320da